// Client-side search / taxonomy filter / URL query state for the supplier
// Product Catalog. Pure so it can be unit-tested alongside `paginate`.
import type { LocationQuery } from 'vue-router'
import type { SupplierProductListItem } from '../types/api'

export const PAGE_SIZES = [25, 50, 100] as const
export const DEFAULT_PAGE_SIZE: number = PAGE_SIZES[0]

export interface CatalogQuery {
    q: string
    area: string
    sub: string
    page: number
    size: number
}

const str = (v: unknown) => (typeof v === 'string' ? v : '')

export function catalogQueryFromRoute(query: LocationQuery): CatalogQuery {
    const size = Number(query.size)
    return {
        q: str(query.q),
        area: str(query.area),
        sub: str(query.sub),
        page: Math.max(1, parseInt(str(query.page), 10) || 1),
        size: (PAGE_SIZES as readonly number[]).includes(size) ? size : DEFAULT_PAGE_SIZE,
    }
}

/** Only non-default values are written so the URL stays short. */
export function catalogQueryToRoute(state: CatalogQuery): Record<string, string> {
    const out: Record<string, string> = {}
    if (state.q) out.q = state.q
    if (state.area) out.area = state.area
    if (state.sub) out.sub = state.sub
    if (state.page > 1) out.page = String(state.page)
    if (state.size !== DEFAULT_PAGE_SIZE) out.size = String(state.size)
    return out
}

export function filterSupplierProducts(
    products: SupplierProductListItem[],
    opts: { q?: string; area?: string; sub?: string },
): SupplierProductListItem[] {
    const q = (opts.q || '').trim().toLowerCase()
    return products.filter(p =>
        (!q || p.name.toLowerCase().includes(q) || (p.pricing_band || '').toLowerCase().includes(q)) &&
        (!opts.area || !!p.subcategories?.some(ps => ps.subcategory.area_id === opts.area)) &&
        (!opts.sub || !!p.subcategories?.some(ps => ps.subcategory.id === opts.sub)),
    )
}
